import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {mergeRight} from 'ramda';


const IconSpinner = ({status, fullscreen, debug, className, style}) => {
    let spinnerClass = fullscreen ? 'dash-spinner-container dx-icon-refresh' : 'dx-icon-refresh';
    if (className) {
        spinnerClass += ` ${className}`;
    }
    return <i style={style ? style : {}} className={spinnerClass}>
        <style>
            {`
                @keyframes spinning {
                    from { transform: rotate(0deg) }
                    to { transform: rotate(360deg) }
                }
                .dx-icon-refresh {
                    animation-name: spinning;
                    animation-duration: 1s;
                    animation-iteration-count: infinite;
                    /* linear | ease | ease-in | ease-out | ease-in-out */
                    animation-timing-function: linear;
                }
            `}
        </style>
    </i>
};

IconSpinner.propTypes = {
    status: PropTypes.object,
    color: PropTypes.string,
    className: PropTypes.string,
    fullscreen: PropTypes.bool,
    style: PropTypes.object,
    debug: PropTypes.bool,
};


function getSpinner(spinnerType) {
    switch (spinnerType) {
        case 'graph':
            return IconSpinner;
        case 'cube':
            return IconSpinner;
        case 'circle':
            return IconSpinner;
        case 'dot':
            return IconSpinner;
        default:
            return IconSpinner;
    }
}

const hiddenContainer = {
    // visibility: 'hidden', position: 'relative'
};

const coveringSpinner = {
    // visibility: 'visible',
    // position: 'absolute',
    top: '0',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

/**
 * A Loading component that wraps any other component and displays a spinner until the wrapped component has rendered.
 */
export default class Loading extends Component {
    render() {
        const {
            loading_state,
            color,
            className,
            style,
            parent_className,
            parent_style,
            fullscreen,
            debug,
            type: spinnerType,
        } = this.props;

        const isLoading = loading_state && loading_state.is_loading;
        const Spinner = isLoading && getSpinner(spinnerType);
        let sstyle = (isLoading ? mergeRight(hiddenContainer, parent_style) : parent_style) || {};
        sstyle['display'] = isLoading ? 'flex' : 'none';

        return (
            <div
                className={parent_className}
                style={sstyle}
            >
                {this.props.children}
                <div style={isLoading ? coveringSpinner : {}}>
                    {isLoading && (
                        <Spinner
                            className={className}
                            style={style}
                            status={loading_state}
                            color={color}
                            debug={debug}
                            fullscreen={fullscreen}
                        />
                    )}
                </div>
            </div>
        );
    }
}

Loading._dashprivate_isLoadingComponent = true;

Loading.defaultProps = {
    type: 'default',
    color: '#119DFF',
};

Loading.propTypes = {
    /**
     * The ID of this component, used to identify dash components
     * in callbacks. The ID needs to be unique across all of the
     * components in an app.
     */
    id: PropTypes.string,

    /**
     * Array that holds components to render
     */
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),

    /**
     * Property that determines which spinner to show
     * one of 'graph', 'cube', 'circle', 'dot', or 'default'.
     */
    type: PropTypes.oneOf(['graph', 'cube', 'circle', 'dot', 'default']),

    /**
     * Boolean that makes the spinner display full-screen
     */
    fullscreen: PropTypes.bool,

    /**
     * If true, the spinner will display the component_name and prop_name
     * while loading
     */
    debug: PropTypes.bool,

    /**
     * Additional CSS class for the spinner root DOM node
     */
    className: PropTypes.string,

    /**
     *  Additional CSS class for the outermost dcc.Loading parent div DOM node
     */
    parent_className: PropTypes.string,

    /**
     * Additional CSS styling for the spinner root DOM node
     */
    style: PropTypes.object,

    /**
     * Additional CSS styling for the outermost dcc.Loading parent div DOM node
     */
    parent_style: PropTypes.object,

    /**
     * Primary colour used for the loading spinners
     */
    color: PropTypes.string,

    /**
     * Object that holds the loading state object coming from dash-renderer
     */
    loading_state: PropTypes.shape({
        /**
         * Determines if the component is loading or not
         */
        is_loading: PropTypes.bool,
        /**
         * Holds which property is loading
         */
        prop_name: PropTypes.string,
        /**
         * Holds the name of the component that is loading
         */
        component_name: PropTypes.string,
    }),
};
